import { gsap } from 'gsap'; 
import { CustomEase } from 'gsap/CustomEase';
import { cursorProximityMove } from '../helper/util';
import { throttle } from 'throttle-debounce';

gsap.registerPlugin(CustomEase);

CustomEase.create('powerBack', 'M0,0 C0.404,0 0.2,0.926 0.482,1.092 0.618,1.172 0.662,1 1,1 ');

const circleIconHover = {
    init() {
        const canHover = window.matchMedia('(hover: hover)').matches;
        if (canHover === true) {   

            let circleIcons = document.querySelectorAll('.js-circle-icon');
            let duration = 1;

            circleIcons.forEach(function(circleIcon) {	
                const iconWrapper = circleIcon.querySelector('.inner');
                gsap.set(circleIcon.querySelector('*'), {'pointerEvents': 'none'});
                

                    circleIcon.addEventListener('mouseenter', () => {  
                        throttleCircleIconEnter(1);
                    });              
                    const throttleCircleIconEnter = throttle(500, (num) => {
                        mouseEnter();
                    });              
                    
                    const mouseEnter = () => {    
                        if (iconWrapper.classList.contains('arrows-down') == true){                    
                            gsap.fromTo(iconWrapper.querySelector('span'), {
                                y: '0%'
                            },
                            {
                                y: '50%',
                                duration: duration,
                                ease: 'back.out(1.7)',
                            });
                        } else if (iconWrapper.classList.contains('arrows-right') == true) {
                            gsap.fromTo(iconWrapper.querySelector('span'), {
                                x: '0%'
                            },
                            {
                                x: '50%',
                                duration: duration,
                                ease: 'back.out(1.7)',
                            });
                        }
                    }   
                
            });

        }
    }
}

const cursorMagnet = {
    init() {
        const canHover = window.matchMedia('(hover: hover)').matches;
        if (canHover === true) {        
            let elems = document.querySelectorAll('.js-cursor-magnet');         
            elems.forEach(function(elem) {	 
                cursorProximityMove(elem);
            });        
        }
    }
}

// const carouselNavFollow = {
// 	init() {

//         var carousels = document.querySelectorAll('.js-swiper');

//         if (carousels.length > 0){

//             const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
//             const mouse = { x: pos.x, y: pos.y };
//             const speed = 0.2;
//             const scale = 0.5;
//             const duration1 = 0.6;
//             const duration2 = duration1*0.5;
                        
            
//             carousels.forEach(function(carousel) {	 

//                 var nextIcon = carousel.querySelector('.swiper-button-next'),
//                     prevIcon = carousel.querySelector('.swiper-button-prev');
                
//                 window.addEventListener('mousemove', e => {    
//                     mouse.x = e.clientX;
//                     mouse.y = e.clientY; 
//                 });
                
//                 gsap.set(nextIcon, {xPercent: -50, yPercent: -50});
//                 gsap.set(prevIcon, {xPercent: -50, yPercent: -50});

//                 nextIcon.style.display = 'block';
//                 nextIcon.style.opacity = '0';
//                 prevIcon.style.display = 'block';
//                 prevIcon.style.opacity = '0';            
                
//                 const nextXSet = gsap.quickSetter(nextIcon, 'x', 'px');
//                 const nextYSet = gsap.quickSetter(nextIcon, 'y', 'px');
//                 const prevXSet = gsap.quickSetter(prevIcon, 'x', 'px');
//                 const prevYSet = gsap.quickSetter(prevIcon, 'y', 'px');  
                
//                 gsap.ticker.add(() => {
                  
//                     // adjust speed for higher refresh monitors
//                     const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio()); 
                    
//                     pos.x += (mouse.x - pos.x) * dt;
//                     pos.y += (mouse.y - pos.y) * dt;
//                     nextXSet(pos.x);
//                     nextYSet(pos.y);
//                     prevXSet(pos.x);
//                     prevYSet(pos.y);                
        
//                 });                

//                 carousel.querySelector('.swiper-wrapper').addEventListener('mouseover', () => {
//                     console.log('mouse over');
//                     gsap.fromTo(nextIcon, duration1, {
//                         scale: scale,
//                     },
//                     {
//                         scale: 1,
//                         ease: 'back.out(1.7)',
//                     });
//                     gsap.fromTo(nextIcon, duration2, {
//                         opacity: 0,
//                     },
//                     {
//                         opacity: 1,
//                     });  
//                     gsap.fromTo(prevIcon, duration1, {
//                         scale: scale,
//                     },
//                     {
//                         scale: 1,
//                         ease: 'back.out(1.7)',
//                     });
//                     gsap.fromTo(prevIcon, duration2, {
//                         opacity: 0,
//                     },
//                     {
//                         opacity: 1,
//                     });                       

//                 });

//                 carousel.querySelector('.swiper-wrapper').addEventListener('mouseout', () => {
//                     console.log('mouse out');
//                     gsap.fromTo(nextIcon, duration2, {
//                         scale: 1,
//                     },
//                     {
//                         scale: scale,
//                         ease: 'power3.inOut',
//                     });
//                     gsap.fromTo(nextIcon, duration2, {
//                         opacity: 1,
//                     },
//                     {
//                         opacity: 0,
//                     });     
//                     gsap.fromTo(prevIcon, duration2, {
//                         scale: 1,
//                     },
//                     {
//                         scale: scale,
//                         ease: 'power3.inOut',
//                     });
//                     gsap.fromTo(prevIcon, duration2, {
//                         opacity: 1,
//                     },
//                     {
//                         opacity: 0,
//                     });                                                

//                 });      

//             });        
            

//         }

// 	},
// };

export {cursorMagnet, circleIconHover};